module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_suns_black-8c328efc6528b7a87927ea16912eebc4.svg";